import React, { useRef } from 'react'
import { getSmallAssetPath } from '@aytm/lib/common/assets.ts'
import { formatPriceWithLocale } from '@aytm/app/swidget/base/questions/Ecommerce/functions.ts'
import { IEcommerceAnswerSchema, IEcommerceQuestionSchema } from '@aytm/app/swidget/base/questions/Ecommerce/types'
import useOnClickOutside from '@aytm/lib/hooks/useOnClickOutside'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import style from './SubmitModal.module.scss'
import nikeStyle from '../Nike.module.scss'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import { ViewportOrientation } from '@aytm/app/swidget/base/modules/viewport/types'

interface ISubmitModalProps {
  answer: IEcommerceAnswerSchema
  schema: IEcommerceQuestionSchema
  totals: number[]
  onCartOpen: () => void
  onModalClose: () => void
}

const SubmitModal = ({ answer, schema, totals, onCartOpen, onModalClose }: ISubmitModalProps) => {
  const viewport = useViewport()
  const { t, languageTag } = useSurveyLocale()
  const modalRef = useRef<HTMLDivElement>(null)
  useOnClickOutside(modalRef, () => onModalClose())
  return (
    <div className={`${style.modalLayout} ${viewport.mobile ? style.modalLayoutMobile : ''}`}>
      <div className={style.modal} ref={modalRef}>
        <button className={style.close} onClick={onModalClose}>
          <div className={style.closeIcon} />
        </button>
        <div className={style.head}>
          <div className={style.addedIcon} />
          <span>{t('questions', 'ec', 'nike', 'added')}</span>
        </div>
        <div className={style.product}>
          {answer.image ? (
            <div
              className={`${style.image} ${
                !answer.not_apply_filter && answer.image.width != answer.image.height ? style.imageFilter : ''
              }`}
              role="img"
              aria-label={answer.image?.alt_text || t('questions', 'img', 'noAlt')}
              style={{
                backgroundImage: `url(${getSmallAssetPath(answer.image)})`
              }}
            />
          ) : (
            <div className={style.noImage}></div>
          )}
          <div className={style.info}>
            <div
              className={`${style.caption} ${
                viewport.mobile
                  ? ViewportOrientation.LANDSCAPE === viewport.orientation
                    ? style.captionMobileLandscape
                    : style.captionMobilePortrait
                  : ''
              }`}
              dangerouslySetInnerHTML={{ __html: answer.text }}
            />
            <div className={nikeStyle.prices}>
              {answer.discounted_price && answer.price > answer.discounted_price ? (
                <>
                  <div
                    className={nikeStyle.newPrice}
                    dangerouslySetInnerHTML={{
                      __html: `${formatPriceWithLocale(answer.discounted_price, schema.price_mask, languageTag, true, false)}`
                    }}
                  />
                  <div
                    className={nikeStyle.lastPrice}
                    dangerouslySetInnerHTML={{
                      __html: `${formatPriceWithLocale(answer.price, schema.price_mask, languageTag, true, false)}`
                    }}
                  />
                </>
              ) : (
                <div
                  className={nikeStyle.defaultPrice}
                  dangerouslySetInnerHTML={{
                    __html: `${formatPriceWithLocale(answer.price, schema.price_mask, languageTag, true, false)}`
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <button
          className={style.viewCart}
          onClick={onCartOpen}
          dangerouslySetInnerHTML={{ __html: `${t('questions', 'ec', 'nike', 'viewCart')} (${totals[0]})` }}
        />
        <button className={style.checkout} onClick={onModalClose}>
          {t('questions', 'ec', 'nike', 'continueShopping')}
        </button>
      </div>
    </div>
  )
}

export default SubmitModal
